export default __webpack_public_path__ + "static/media/book_freedom_a_teachings.8a227055.png";